<div class="language-selector">
  <button
    type="button"
    class="language-selector-trigger"
    (click)="toggle($event)"
    [attr.aria-label]="'language.select' | translate"
    aria-haspopup="listbox"
    [attr.aria-expanded]="isOpen"
  >
    <span class="selected-flag" aria-hidden="true">{{selectedLanguage.flag}}</span>
    <span>{{selectedLanguage.labelKey | translate}}</span>
    <i class="mdi mdi-chevron-down selector-chevron" aria-hidden="true"></i>
  </button>

  <div *ngIf="isOpen" class="language-selector-menu" role="listbox">
    <button
      *ngFor="let language of languages"
      type="button"
      class="language-selector-option"
      [class.active]="language.code === selectedLanguage.code"
      [attr.aria-selected]="language.code === selectedLanguage.code"
      role="option"
      (click)="changeLanguage(language.code, $event)"
    >
      <span class="option-flag" aria-hidden="true">{{language.flag}}</span>
      <span>{{language.labelKey | translate}}</span>
    </button>
  </div>
</div>
